import { render, staticRenderFns } from "./AddAdminUser.vue?vue&type=template&id=21e6d1d1&scoped=true&"
import script from "./AddAdminUser.vue?vue&type=script&lang=js&"
export * from "./AddAdminUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e6d1d1",
  null
  
)

export default component.exports